// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExportButton-module__exportButtonBase____5RxZ {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 90px;
}

/* Icon button styles */
.ExportButton-module__iconButton___ztp3X {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    transition: transform 0.2s ease;
}

    .ExportButton-module__iconButton___ztp3X:hover {
        transform: scale(1.1);
    }

    .ExportButton-module__iconButton___ztp3X:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/ExportButton/ExportButton.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,+BAA+B;AACnC;;IAEI;QACI,qBAAqB;IACzB;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB","sourcesContent":[".exportButtonBase {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 90px;\n}\n\n/* Icon button styles */\n.iconButton {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    transition: transform 0.2s ease;\n}\n\n    .iconButton:hover {\n        transform: scale(1.1);\n    }\n\n    .iconButton:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"exportButtonBase": `ExportButton-module__exportButtonBase____5RxZ`,
	"iconButton": `ExportButton-module__iconButton___ztp3X`
};
export default ___CSS_LOADER_EXPORT___;
